// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Folder = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Folder = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Folder = _exports.Folder = function Folder(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M17.5 13.3747V14.1663C17.5 15.833 16.6667 16.6663 15 16.6663H5C3.33333 16.6663 2.5 15.833 2.5 14.1663V13.3747C2.5 13.2363 2.61171 13.1247 2.75004 13.1247H17.25C17.3883 13.1247 17.5 13.2363 17.5 13.3747ZM15 5.83301H10.8333L8.33333 3.33301H5C3.33333 3.33301 2.5 4.16634 2.5 5.83301V11.6247C2.5 11.763 2.61171 11.8747 2.75004 11.8747H17.25C17.3883 11.8747 17.5 11.763 17.5 11.6247V8.33301C17.5 6.66634 16.6667 5.83301 15 5.83301Z",
      fill: "currentColor"
    }));
  };
});
